import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/nav/site/page',
    method: 'get',
    params
  })
}

export function getById(id) {
  return request({
    url: `/nav/site/getById/${id}`,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'nav/site/',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/nav/site/',
    method: 'put',
    data
  })
}

export function remove(ids) {
  return request({
    url: `/nav/site/delete/${ids}`,
    method: 'delete'
  })
}

export function getMaxSortByCategoryId(categoryId) {
  return request({
    url: '/nav/site/getMaxSortByCategoryId',
    method: 'get',
    params: {
      categoryId
    }
  })
}

/**
 * 采集网站图标
 */
export function collectSiteIcon(siteUrl) {
  return request({
    url: '/nav/site/collectSiteIcon',
    method: 'get',
    params: {
      siteUrl
    }
  })
}

/**
 * 获取匹配网站
 */
export function getMatch(siteUrl) {
  return request({
    url: '/nav/site/getMatch',
    method: 'get',
    params: {
      siteUrl
    }
  })
}

/**
 * AI 智能匹配
 */
export function aiSmartMatch(siteUrl) {
  return request({
    url: '/nav/site/aiSmartMatch',
    method: 'get',
    params: {
      siteUrl
    }
  })
}

/**
 * 更新排序
 */
export function updateSort(data) {
  return request({
    url: '/nav/site/updateSort',
    method: 'put',
    data
  })
}

/**
 * 更新点击量
 */
export function updateClickCount(id) {
  return request({
    url: `/nav/site/updateClickCount/${id}`,
    method: 'put'
  })
}

/**
 * 查询列表
 */
export function listByUserImport(params) {
  return request({
    url: '/nav/site/listByUserImport',
    method: 'get',
    params
  })
}
